import { render, staticRenderFns } from "./WorkerEdit.vue?vue&type=template&id=1dc0d912&scoped=true"
import script from "./WorkerEdit.vue?vue&type=script&lang=js"
export * from "./WorkerEdit.vue?vue&type=script&lang=js"
import style0 from "./WorkerEdit.vue?vue&type=style&index=0&id=1dc0d912&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dc0d912",
  null
  
)

export default component.exports